import styled from '@emotion/styled'
import { Z_INDEX } from '@liveHelper/constants'
import {
  ActionButton,
  FadeInAndUpTransition,
  FadeInNoDelayAnimation,
  TRANSITION_TIMING_FUNCTION,
} from '@oneToOne/shared/styles'

const MESSAGE_PREVIEW_CONTAINER_PADDING = 24
const MIN_WIDTH = 70
const MAX_WIDTH = 210

export const MessagePreviewGroup = styled.div`
  position: relative;
  pointer-events: auto;

  @keyframes bounce {
    0% {
      transform: translateY(0px);
    }

    3% {
      transform: translateY(-12px);
    }

    6% {
      transform: translateY(0px);
    }

    8% {
      transform: translateY(-7px);
    }

    10% {
      transform: translateY(0px);
    }

    12% {
      transform: translateY(-3px);
    }

    14% {
      transform: translateY(0px);
    }
  }

  animation: bounce 8s ${TRANSITION_TIMING_FUNCTION} infinite;
`

export const MessagePreviewContainer = styled.div`
  ${FadeInAndUpTransition}
  display: flex;
  min-width: ${MIN_WIDTH}px;
  max-width: ${MAX_WIDTH}px;
  padding: 10px 14px;
  gap: 8px;
  position: relative;
  box-shadow:
    0px 3px 6px -4px #0000001f,
    0px 6px 16px 0px #00000014,
    0px 9px 28px 8px #0000000d;
  background: var(--white);
  border-radius: var(--border-radius-sm);
  flex-direction: column;
`

export const MessagePreviewBadge = styled.span`
  background: var(--red3);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  position: absolute;
  top: -8px;
  inset-inline-end: var(--spacing-16);
  color: var(--white);

  & span {
    ${FadeInAndUpTransition}
  }
`

export const MessagePreviewCloseButton = styled(ActionButton)`
  position: absolute;
  top: -11px;
  inset-inline-end: -10px;
  z-index: ${Z_INDEX.FLOATING_ACTION};
  color: var(--white);
`

export const MessagePreviewAvatar = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border: 2px solid var(--green);
  border-radius: 50%;
  overflow: hidden;
`

export const MessagePreviewContent = styled.div`
  ${FadeInNoDelayAnimation}
  color: var(--blk2);
  font-size: 12px;
  white-space: pre-line; /* Preserve line breaks */
  word-break: break-word; /* Break words to next line */
  overflow-wrap: break-word; /* Break words to next line */
  max-width: 100%;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`

export const MessagePreviewContainerStack = styled.div<{
  width: number
  height: number
}>`
  position: absolute;
  top: 8px;
  inset-inline-start: 8px;
  width: ${({ width }) => width + MESSAGE_PREVIEW_CONTAINER_PADDING}px;
  height: ${({ height }) => height + MESSAGE_PREVIEW_CONTAINER_PADDING}px;
  max-width: ${MAX_WIDTH}px;
  box-shadow:
    0px 3px 6px -4px #0000001f,
    0px 6px 16px 0px #00000014,
    0px 9px 28px 8px #0000000d;
  z-index: -1;
  border-radius: var(--border-radius-sm);
  background: var(--gray-2);
`

export const FileNameText = styled.span`
  font-size: 12px;
  line-height: 12px;
  color: var(--blk2);
  margin-bottom: 4px;
`

export const FileSizeText = styled.span`
  font-size: 10px;
  line-height: 12px;
  color: var(--blk2);
`
